import { NavigationItemStoryblok } from 'storyblok-types';

export const flattenFlyout = (
  flyout: NavigationItemStoryblok,
): NavigationItemStoryblok[] => {
  if (!flyout?.flyoutColumns || !Array.isArray(flyout.flyoutColumns)) {
    return [];
  }
  return flyout.flyoutColumns
    ?.map((column) => (column?.items ? column.items : []))
    .flat(1);
};
